/**
 * Severity is Bloom's classification and the most important semantic color in the
 * product (ANA.4, style guide §2.5). The mapping is fixed:
 *
 *   ERROR  solid    error-700 fill, white text
 *   WARN   tinted   warning-100 fill, warning-800 text, warning-200 border
 *   INFO   neutral  navy-100 fill, navy-700 text, navy-300 border
 *
 * Visual weight descends with severity. Do not invert it, do not add a fourth
 * level, and do not render "Error", "Warning" or "Critical" — the labels are
 * uppercase ERROR / WARN / INFO.
 */

export type Severity = 'ERROR' | 'WARN' | 'INFO'

export const SEVERITY_ORDER: readonly Severity[] = ['ERROR', 'WARN', 'INFO']

export const severityClasses: Record<Severity, string> = {
  ERROR: 'bg-[var(--severity-error-bg)] text-[var(--severity-error-fg)]',
  WARN: 'bg-[var(--severity-warn-bg)] text-[var(--severity-warn-fg)] border border-[var(--severity-warn-border)]',
  INFO: 'bg-[var(--severity-info-bg)] text-[var(--severity-info-fg)] border border-[var(--severity-info-border)]',
}

/** The registered rule set (ANA.3). Counts move with the rule-set version (ANA.9). */
export const RULE_COUNTS = { total: 279, ERROR: 62, WARN: 158, INFO: 59 } as const
